import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CloseSmall",
  "use": "CloseSmall-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"CloseSmall\"><path d=\"M12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm-1.768 3.172a.75.75 0 1 0-1.06 1.06L10.939 12l-1.767 1.768a.75.75 0 1 0 1.06 1.06L12 13.061l1.768 1.767a.75.75 0 1 0 1.06-1.06L13.061 12l1.767-1.768a.75.75 0 0 0-1.06-1.06L12 10.939Z\" fill=\"#BCC2CC\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol